import { Fragment } from 'react'
import { Divider, H, P, Wrapper } from '@farewill/ui'

import { RESOURCES, useArrayResource } from 'api'
import MessageBox from 'components/message-box'
import { WillStorageRecord } from 'lib/models/will-storage-record'
import WillStorageRecordBlock from './will-storage-record-block'

type Props = {
  contactId: number
}

const Summary = ({ contactId }: Props) => {
  const { query, updateMutation } = useArrayResource<WillStorageRecord>({
    resource: RESOURCES.WILL_STORAGE_RECORDS,
    params: `contactId=${contactId}`,
  })

  if (query.isLoading) return <P>Loading...</P>

  if (query.isError) {
    return (
      <MessageBox error>
        Something went wrong loading will storage records.
      </MessageBox>
    )
  }

  const records = query.data?.data ?? []

  return (
    <Wrapper maxWidth="680px">
      <H size="M">Overview</H>
      {records.length > 1 && (
        <P>
          This customer has multiple wills in storage. Only the latest version
          which has been signed and witnessed is valid.
        </P>
      )}
      {records.length === 0 && (
        <P>No will storage records found for this customer.</P>
      )}
      {records.map((record, index) => (
        <Fragment key={record.id}>
          <WillStorageRecordBlock
            record={record}
            updateMutation={updateMutation}
          />
          {index < records.length - 1 && <Divider data-testid="divider" />}
        </Fragment>
      ))}
    </Wrapper>
  )
}

export default Summary
